<template>
    <div :class="`c-alert--${type}`" class="c-alert">
        <font-awesome-icon :icon="icon" class="c-alert__icon" v-if="!hideIcon"></font-awesome-icon>
        <slot></slot>
    </div>
</template>

<script>
    export default {
        name: "base-alert",
        props: {
            type: {
                type: String,
                default: 'info',
                validator: function (value) {
                    return ['info', 'success', 'error'].indexOf(value) !== -1;
                }
            },
            hideIcon: {
                type: Boolean,
                default: false,
            }
        },
        computed: {
            icon() {
                switch (this.type) {
                    case 'info':
                        return ['fas', 'info-circle'];
                    case 'success':
                        return ['fas', 'check-circle'];
                    case 'error':
                        return ['fas', 'engine-warning'];
                }
            }
        }
    }
</script>

<style scoped>

</style>